import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { VscEditorLayout } from "react-icons/vsc";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import RefreshIcon from "@mui/icons-material/Refresh";
import DownloadIcon from "@mui/icons-material/Download";
import { RiSendPlaneFill, RiSidebarUnfoldFill } from "react-icons/ri";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import PropTypes from "prop-types";
import {openTheEditor} from "../payment/helper";
import {FileActionButton} from "./FileActionButton";

export default function FileActionButtons({ file, currentLang, openConfirmation, openSelectOCRTypeConfirmation, loadingQualityId }) {
    return (
        <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
            {/* Open Editor */}
            {(file.status === "completed" || file.status === "delivered" || file.status === "accepted") && (
                <FileActionButton
                    title="Open Editor"
                    onClick={() => openTheEditor(file.digitization_id, currentLang)}
                    icon={<VscEditorLayout />}
                    sx={{ bgcolor: "#f3e8f5", "&:hover": { bgcolor: "#e2c8e6" }, border: "1px solid #e2c8e6" }}
                />
            )}

            {/* Download File */}
            {file.url && (
                <FileActionButton
                    title="Download File"
                    href={file.url}
                    icon={<TextSnippetIcon />}
                    sx={{ bgcolor: "#e3f2fd", "&:hover": { bgcolor: "#bbdefb" }, border: "1px solid #2196f3" }}
                />
            )}

            {/* Rerun Digitization */}
            {file.status === "partially_completed" && (
                <FileActionButton
                    title="Rerun Digitization"
                    onClick={() => openConfirmation("file", "rerun", file.id)}
                    icon={<RefreshIcon />}
                    sx={{ bgcolor: "#f5ebe8", "&:hover": { bgcolor: "#e6cec8" }, border: "1px solid #f5ebe8" }}
                />
            )}

            {/* Deliver File */}
            {file.status === "completed" && (
                <FileActionButton
                    title="Deliver File"
                    onClick={() => openConfirmation("file", "deliver", file.id)}
                    icon={<RiSendPlaneFill />}
                    sx={{ bgcolor: "#e8f5e9", "&:hover": { bgcolor: "#c8e6c9" }, border: "1px solid #4caf50" }}
                />
            )}

            {/* Digitize File */}
            {(file.status === "pending" || file.status === "partially_completed" || file.status === "failed") && (
                <FileActionButton
                    title="Digitize File"
                    onClick={() => openSelectOCRTypeConfirmation("file", "digitize", file.id)}
                    icon={<RiSidebarUnfoldFill />}
                    sx={{ bgcolor: "#e8f5e9", "&:hover": { bgcolor: "#c8e6c9" }, border: "1px solid #4caf50" }}
                />
            )}

            {file.url && (
                <FileActionButton
                    title={
                        loadingQualityId === file.id
                            ? "Checking quality..."
                            : "Start Quality Check"
                    }
                    onClick={() => {
                        if (loadingQualityId !== file.id) {
                            openConfirmation("file", "startQualityCheck", file.id);
                        }
                    }}
                    icon={
                        loadingQualityId === file.id ? (
                            <CircularProgress size={18} />
                        ) : (
                            <MonitorHeartIcon />
                        )
                    }
                    sx={{bgcolor: "#e3f2fd", "&:hover": {bgcolor: "#bbdefb"}, border: "1px solid #2196f3"}}
                />
            )}

            {/* Download Digitization */}
            {file.digitization_data_path && (
                <FileActionButton
                    title="Download Digitization"
                    href={file.digitization_data_path}
                    icon={<DownloadIcon />}
                    sx={{ bgcolor: "#e3f2fd", "&:hover": { bgcolor: "#bbdefb" }, border: "1px solid #2196f3" }}
                />
            )}
        </Box>
    );
}
FileActionButtons.propTypes = {
    file: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        status: PropTypes.string,
        url: PropTypes.string,
        digitization_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        digitization_data_path: PropTypes.string,
    }).isRequired,
    currentLang: PropTypes.string.isRequired,
    openConfirmation: PropTypes.func.isRequired,
    openSelectOCRTypeConfirmation: PropTypes.func.isRequired,
    loadingQualityId: PropTypes.number,
};